// document.addEventListener('DOMContentLoaded', function() {
//   // const yesButton = document.querySelector('.age-btn.yes');
//   const popupOverlay = document.querySelector('.popup-popup-overlay-newsletter');
//   const noButton = document.querySelector('.age-btn.no');
//   const closeButton = document.querySelector('.popup-popup-close-newsletter'); // Close button
//   const popupContainer = document.querySelector('.popup-popup-container-newsletter'); // Popup container

//   yesButton.addEventListener('click', function() {
//     setTimeout(function() {
//       popupOverlay.classList.add('active');
//     }, 5000);
//   });

//   noButton.addEventListener('click', function() {
//   });

 
//   closeButton.addEventListener('click', function() {
//     popupOverlay.classList.remove('active');
//   });


//   window.addEventListener('click', function(event) {
//     if (!popupContainer.contains(event.target) && popupOverlay.classList.contains('active')) {
//       popupOverlay.classList.remove('active');
//     }
//   });
// });

 (function() {
    const SESSION_KEY = "exitPopupShown";
    const MOUSE_Y_THRESHOLD = 20;          // pixels from top for exit intent
    const MOBILE_TIMEOUT_MS = 20000;       // 20s delay on mobile
    const MOBILE_SCROLL_FRACTION = 0.5;    // must scroll 50% of viewport height

    // Detect touch devices
    function isTouchDevice() {
      return (('ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
    }

    // DOM ready helper
    function onReady(fn) {
      if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(fn, 0);
      } else {
        document.addEventListener("DOMContentLoaded", fn);
      }
    }

    onReady(function() {
      const popup = document.getElementById("exitPopup");
      const closeBtn = document.getElementById("closePopup");
      const popupContainer = popup?.querySelector(".popup-popup-container-newsletter");
      if (!popup || !popupContainer) return;

      let triggered = false;
      const alreadyShown = sessionStorage.getItem(SESSION_KEY) === "true";

      // ----- Show / Hide -----
      function showPopup() {
        if (triggered || alreadyShown) return;
        triggered = true;
        popup.classList.add("active");
        popup.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden"; // lock scroll
      }

      function hidePopup() {
        popup.classList.remove("active");
        popup.setAttribute("aria-hidden", "true");
        document.body.style.overflow = ""; // restore scroll
      }

      function triggerOnceAndRemember() {
        if (sessionStorage.getItem(SESSION_KEY)) return;
        if(!sessionStorage.getItem("age-popup-closed")) return;
        if (window.location.pathname === "/collections/wholesale-bulk") return;
        showPopup();
        try { sessionStorage.setItem(SESSION_KEY, "true"); } catch (e) {}
      }

      // ----- Close logic -----
      closeBtn?.addEventListener("click", (e) => {
        e.preventDefault();
        hidePopup();
      });

      // ✅ Close when clicking outside popup box
      popup.addEventListener("click", (e) => {
        if (!popupContainer.contains(e.target)) {
          hidePopup();
        }
      });

      // Close on ESC
      document.addEventListener("keydown", (e) => {
        if ((e.key === "Escape" || e.key === "Esc") && popup.classList.contains("active")) {
          hidePopup();
        }
      });

      // ----- Desktop exit-intent -----
      document.addEventListener("mouseout", (e) => {
        if (triggered || sessionStorage.getItem(SESSION_KEY)) return;
        const from = e.relatedTarget || e.toElement;
        if (!from && typeof e.clientY === "number" && e.clientY <= MOUSE_Y_THRESHOLD) {
          triggerOnceAndRemember();
        }
      });

      // ----- Mobile fallback -----
      if (isTouchDevice()) {
        // Show after delay
        const mobileTimer = setTimeout(() => {
          if (!sessionStorage.getItem(SESSION_KEY) && !triggered) {
            triggerOnceAndRemember();
          }
        }, MOBILE_TIMEOUT_MS);

        // Scroll-based trigger (delayed & distance-checked)
        let scrollStartTime = null;
        let minScrollDistance = window.innerHeight * MOBILE_SCROLL_FRACTION; // must scroll 50% of screen

        function onMobileScroll() {
          if (triggered || sessionStorage.getItem(SESSION_KEY)) {
            window.removeEventListener("scroll", onMobileScroll);
            clearTimeout(mobileTimer);
            return;
          }

          // Record first scroll timestamp
          if (!scrollStartTime) {
            scrollStartTime = Date.now();
          }

          const scrolledEnough = window.scrollY > minScrollDistance;
          const waitedEnough = (Date.now() - scrollStartTime) > 3000; // wait at least 3s after first scroll

          if (scrolledEnough && waitedEnough) {
            triggerOnceAndRemember();
            window.removeEventListener("scroll", onMobileScroll);
            clearTimeout(mobileTimer);
          }
        }

        window.addEventListener("scroll", onMobileScroll, { passive: true });
      }
    });
  })();

